import { Injectable, NgZone, DestroyRef, inject } from '@angular/core';
import { Router, ActivationEnd, Event as RouterEventUnion } from '@angular/router';
import { filter, map, distinctUntilChanged } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class RumIntegrationService {
  private destroyRef = inject(DestroyRef);

  constructor(
    private router: Router,
    private zone: NgZone,
  ) {
    // Active le mode manuel si dispo, sans réveiller Angular:
    this.zone.runOutsideAngular(() => (window as any).dtrum?.enableManualPageDetection?.());

    // Déclenche setPage uniquement au dernier ActivationEnd (feuille)
    this.router.events
      .pipe(
        filter(
          (e: RouterEventUnion): e is ActivationEnd =>
            e instanceof ActivationEnd && !e.snapshot.firstChild,
        ),
        map(e => {
          const snapshot = e.snapshot;
          const group = snapshot.routeConfig?.path ?? snapshot.data?.['rumGroup'] ?? '(root)';
          const name = this.router.url; // inclut hash/query si useHash
          return { name, group };
        }),
        distinctUntilChanged((a, b) => a.name === b.name && a.group === b.group),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(({ name, group }) => {
        // Appels Dynatrace hors Angular pour éviter les micro/macro-tâches inutiles
        this.zone.runOutsideAngular(() => (window as any).dtrum?.setPage?.({ name, group }));
      });
  }

  reportJsError(err: any) {
    this.zone.runOutsideAngular(() => {
      try {
        (window as any).dtrum?.reportError?.(err instanceof Error ? err : new Error(String(err)));
      } catch {}
    });
  }
}
